'use es6';

import UIList from 'UIComponents/list/UIList';
import UILink from 'UIComponents/link/UILink';
import Routes from 'ContentUtils/Routes';
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
const Page = ({
  label,
  id
}) => /*#__PURE__*/_jsx(UILink, {
  href: Routes.inpageEdit(id),
  external: true,
  children: label
});
const PagesList = ({
  pages = []
}) => /*#__PURE__*/_jsx(UIList, {
  styled: true,
  children: pages.map(page => /*#__PURE__*/_createElement(Page, Object.assign({}, page, {
    key: page.id
  })))
});
export default PagesList;